import axios, { AxiosError, AxiosResponse } from "axios";
//import { resolve } from "dns";
import { toast } from "react-toastify";
import { history } from "../..";
import { PaginatedResponse } from "../models/Pagination";
import { store } from "../store/configureStore";


axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.defaults.withCredentials = true;

const responseBody = (response: AxiosResponse) => response.data;

axios.interceptors.request.use(config => {
    const token = store.getState().account.user?.token;
    if (token) config.headers!.Authorization = `Bearer ${token}`;
    return config;
})


const sleep = () => new Promise(resolve => setTimeout(resolve, 500))

axios.interceptors.response.use(async response => {
    if(process.env.NODE_ENV === 'development') await sleep();
      
    const pagination = response.headers['pagination']
    if(pagination)
    {
        response.data = new PaginatedResponse(response.data,JSON.parse(pagination));
        console.log(response );
        return response
    }
    return response;
}, (error: AxiosError) => {
    // console.log('caught by interceptor');
    //to override type safety use ! 
    const { data, status } = error.response!;
    //for the toastify
    switch (status) {
        case 400:
            if (data.errors) {
                const modelStateError: string[] = [];
                for (const key in data.errors) {
                    if (data.errors[key]) {
                        modelStateError.push(data.errors[key]);
                    }

                }
                throw modelStateError.flat();
            }
            toast.error(data.title)
            break;
        case 401:
            toast.error(data.title)
            break;

        case 500:
            //    history.push('/server-error')

            history.push({
                pathname: '/server-error',
                state: { error: data }
            });
            // toast.error(data.title)
            break;

        default:
            break;
    }
    return Promise.reject(error.response);
})


const requests = {
    get: (url: string,params?:URLSearchParams) => axios.get(url,{params}).then(responseBody),
    post: (url: string, body: {}) => axios.post(url, body).then(responseBody),
    put: (url: string, body: {}) => axios.put(url, body).then(responseBody),
    delete: (url: string) => axios.delete(url).then(responseBody),


}


const Catalog = {
    list: (params:URLSearchParams) => requests.get("products",params),
    details: (id: number) => requests.get(`products/${id}`),
    fetchFilters:() => requests.get("products/filters")


}


const Basket = {
    get:() => requests.get("basket"),
    addItem : (productId: number,quantity  = 1) => requests.post(`basket?productId=${productId}&quantity=${quantity}`,{}),
    removeItem : (productId: number,quantity  = 1) => requests.delete(`basket?productId=${productId}&quantity=${quantity}`)

}


const Account ={
    login:(values :any) => requests.post("account/login",values),
    register:(values :any) => requests.post("account/register",values),
    currentUser:() => requests.get("account/currentUser"),
    fetchAddress :() => requests.get("account/savedAddress")
}

const Orders = {
    list : () => requests.get('orders'),
    fetch: (id : number) => requests.get(`orders/${id}`),
    create : (values : any) => requests.post('orders',values)

}

const TestErrors = {
    get400Error: () => requests.get('buggy/bad-request'),
    get401Error: () => requests.get('buggy/unauthorised'),
    get404Error: () => requests.get('buggy/not-found'),
    get500Error: () => requests.get('buggy/server-error'),
    getValidationError: () => requests.get('buggy/validation-error')
}


const Payments = {
    createPaymentIntent:() => requests.post('payments',{})

}


const agent = {
    Catalog,
    TestErrors,
    Basket,
    Account,
    Orders,
    Payments

}

export default agent
